/**
 * `paramsRaw` is the react-hook-form string representation of a condition's `params: string[]`
 * while it's being edited — it never crosses the network boundary (submission maps it back to a
 * real `params` array). Newline is the delimiter: unlike comma, it can never appear in a value
 * committed from a single-line param input (typed, blurred, or pasted — multi-line paste is
 * split into separate params before it ever reaches `paramsRaw`), so param values that contain a
 * literal comma round-trip correctly.
 */
const PARAMS_RAW_DELIMITER = '\n';

export const serializeParamsRaw = (params: string[]): string => params.join(PARAMS_RAW_DELIMITER);

export const parseParamsRaw = (paramsRaw: string): string[] =>
  paramsRaw
    .split(PARAMS_RAW_DELIMITER)
    .map((s) => s.trim())
    .filter(Boolean);
